import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux'
import Notifications from 'react-notification-system-redux'
import validator from 'validator'

import { url, handleCommonEditActions, validationMessage, getPrerequisitesArray } from '../../../common/helpers'
import * as formatters from '../../../common/formatters'
import { Form, InputField, CheckboxField, SelectField, SubmitButton } from '../../../common/form'
import { createGetTrailerTypeByIDSelector, createGetCurrentTrailerTypeStatusSelector } from '../selectors'
import * as trailerTypesActionCreators from '../actionCreators'
import { LoadingOverlay } from '../../../common/loading_overlay'
import { preparePrerequisitesFetchStatusSelectors } from '../../../common/prerequisites/selectors'
import { preparePrerequisitesActionCreators } from '../../../common/prerequisites/actionCreators'

import PermissionsCheck from '../../auth/components/PermissionsCheck'
import { PERMS } from '../permissions'

const componentIdentifier = 'trailer_types_edit'
const prerequisites = ['transport_types', 'cargo_types', 'vehicle_types', 'goods_types']

class TrailerTypesEdit extends Component {
    defaultValues = {
        width: 0,
        height: 0,
        length: 0,
        weight: 0,
        axles_count: 0,
    }

    validationRules = {
        name: value => validator.isEmpty(String(value)) && validationMessage('isEmpty'),
        width: value => !validator.isFloat(String(value)) && validationMessage('isFloat'),
        height: value => !validator.isFloat(String(value)) && validationMessage('isFloat'),
        length: value => !validator.isFloat(String(value)) && validationMessage('isFloat'),
        weight: value => !validator.isInt(String(value)) && validationMessage('isInt'),
        axles_count: value => !validator.isInt(String(value)) && validationMessage('isInt'),
    }

    state = {
        values: this.defaultValues,
    }

    setValues = (values, callback) => {
        this.setState(
            {
                values,
            },
            callback
        )
    }

    handleChangeValues = values => {
        this.setValues(values)
    }

    handleSubmit = values => {
        this.setValues(values, () => {
            this.handleSave()
        })
    }

    handleSave = () => {
        this.props.actions.saveTrailerType(this.state.values)
    }

    componentDidMount() {
        this.props.match.params.trailerTypeID && this.props.actions.fetchTrailerType(this.props.match.params.trailerTypeID)
        this.props.actions.fetchPrerequisites()
    }

    componentWillReceiveProps(nextProps) {
        handleCommonEditActions(this.props, nextProps, () => {
            this.props.redirect(url(this.props.match, 'trailer-types'))
        })

        if (JSON.stringify(nextProps.trailerType) !== JSON.stringify(this.props.trailerType) || (nextProps.trailerType && !this.state.values.id)) {
            this.setValues(nextProps.trailerType.toJS())
        }
    }

    render() {
        document.title = formatters.titleFormatter(this.props.intl.formatMessage({ id: 'modules.trailerTypes.heading' }))

        return (
            <PermissionsCheck hasAny={Object.values(PERMS)} noPermissionsPage>
                <div className={'page-inner '+(document.body.classList.contains('mobile-menu-open') ? 'sidebar-visible' : '')}>
                    <div id="main-wrapper">
                        <div className="row">
                            <div className="col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4">
                                <div className="panel panel-white">
                                    <div className="panel-body panel-padding">
                                        <div className="panel-head">
                                            <h4>
                                                <FormattedMessage id="modules.trailerTypes.heading" /> -{' '}
                                                {this.props.trailerType ? (
                                                    <FormattedMessage id="fields.itemEdit" />
                                                ) : (
                                                    <FormattedMessage id="fields.itemCreate" />
                                                )}
                                            </h4>
                                        </div>
                                        <LoadingOverlay
                                            active={
                                                this.props.prerequisites.status.get('fetching') ||
                                                this.props.status.get('fetching') ||
                                                this.props.status.get('saving')
                                            }
                                        >
                                            <PermissionsCheck hasAny={Object.values(PERMS)}>
                                                <Form
                                                    values={this.state.values}
                                                    validationRules={this.validationRules}
                                                    onChange={this.handleChangeValues}
                                                    onSubmit={this.handleSubmit}
                                                    isEdit={Boolean(this.props.trailerType)}
                                                >
                                                    <InputField
                                                        id="name"
                                                        label={this.props.intl.formatMessage({ id: 'fields.name' })}
                                                        className="wp-50"
                                                    />
                                                    <InputField
                                                        id="length"
                                                        label={this.props.intl.formatMessage({ id: 'fields.lenght' })}
                                                        className="wp-20"
                                                    />
                                                    <InputField
                                                        id="width"
                                                        label={this.props.intl.formatMessage({ id: 'fields.width' })}
                                                        className="wp-20"
                                                    />
                                                    <InputField
                                                        id="height"
                                                        label={this.props.intl.formatMessage({ id: 'fields.height' })}
                                                        className="wp-20"
                                                    />
                                                    <InputField
                                                        id="weight"
                                                        label={this.props.intl.formatMessage({ id: 'fields.weight' })}
                                                        className="wp-20"
                                                    />
                                                    <InputField
                                                        id="axles_count"
                                                        label={this.props.intl.formatMessage({ id: 'fields.axlesCount' })}
                                                        className="wp-20"
                                                    />
                                                    <InputField
                                                        id="capacity_pallets"
                                                        label={this.props.intl.formatMessage({ id: 'fields.capacityPallets' })}
                                                        className="wp-20"
                                                    />
                                                    <CheckboxField id="is_secured" label={this.props.intl.formatMessage({ id: 'fields.secured' })} />
                                                    <CheckboxField id="is_cooled" label={this.props.intl.formatMessage({ id: 'fields.cooled' })} />

                                                    <SelectField
                                                        id="transport_types"
                                                        label={this.props.intl.formatMessage({ id: 'fields.transportTypes' })}
                                                        values={getPrerequisitesArray(this.props.prerequisites.values.get('transport_types'))}
                                                        multi
                                                    />

                                                    <SelectField
                                                        id="vehicle_types"
                                                        label={this.props.intl.formatMessage({ id: 'fields.vehicleTypes' })}
                                                        values={getPrerequisitesArray(this.props.prerequisites.values.get('vehicle_types'))}
                                                        multi
                                                    />

                                                    <SelectField
                                                        id="cargo_types"
                                                        label={this.props.intl.formatMessage({ id: 'fields.cargoTypes' })}
                                                        values={getPrerequisitesArray(this.props.prerequisites.values.get('cargo_types'))}
                                                        multi
                                                    />

                                                    <SelectField
                                                        id="goods_types"
                                                        label={this.props.intl.formatMessage({ id: 'fields.goodsTypes' })}
                                                        values={getPrerequisitesArray(this.props.prerequisites.values.get('goods_types'))}
                                                        multi
                                                    />

                                                    <div className="btns-form">
                                                        <Link to={url(this.props.match, 'trailer-types')} className="btn btn-addon btn-default">
                                                            <i className="far fa-chevron-left" /> <FormattedMessage id="buttons.back" />
                                                        </Link>
                                                        <SubmitButton
                                                            perms={Object.values(PERMS)}
                                                            isEdit={Boolean(this.props.trailerType)}
                                                            className="btn-addon pull-right"
                                                        />
                                                    </div>
                                                </Form>
                                            </PermissionsCheck>
                                        </LoadingOverlay>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PermissionsCheck>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        trailerType: createGetTrailerTypeByIDSelector(ownProps.match.params.trailerTypeID)(state),
        status: createGetCurrentTrailerTypeStatusSelector()(state),
        prerequisites: preparePrerequisitesFetchStatusSelectors(componentIdentifier, prerequisites, state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            ...bindActionCreators(
                {
                    ...trailerTypesActionCreators,
                    ...preparePrerequisitesActionCreators(componentIdentifier, prerequisites),
                },
                dispatch
            ),
        },
        redirect: toURL => dispatch(push(toURL)),
        notify: (notification, type) => dispatch(Notifications.show(notification, type)),
    }
}

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(TrailerTypesEdit)
)
